import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'highlightSearch',
})
export class HighlightSearchPipe implements PipeTransform {
  transform(value: any, args: any): any {
    try {
      if (!args) {
        return value;
      }

      const regex = new RegExp(args, 'gi');
      const match = value.match(regex);

      if (!match) {
        return value;
      }

      return value.replace(regex, `<i class="highlight">${match[0]}</i>`);
    }
    catch (e) {
      return value;
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/shared/HighlightSearchPipe.pipe.ts